<template>
  <div v-loading="loading" class="page_box">
    <div class="head_div">
      <div class="data_div">
        <div v-for="({ name, value }, index) in dataList" :key="index">
          <h5>{{ name }}</h5>
          <span :class="index == 2 ? 'colorsp' : ''" @click="goPage(index)">
            <i> {{ value }} </i>
            <em>亩</em>
            <img
              v-if="index == 2"
              src="~@/assets/images/Insurance/arrow.svg"
              alt=""
            />
          </span>
        </div>
      </div>
      <div class="date_div" @click="dialogVisible = true">
        <img src="~@/assets/images/Insurance/icon4.png" alt="" />
        <div>
          <span>投保日历</span>
          <img src="~@/assets/images/Insurance/arrow.svg" alt="" />
        </div>
      </div>
    </div>
    <div>
      <div class="time_div">
        <span>保险统计</span>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="medium"
          :picker-options="pickerDateOptions"
          @change="policyOverviewData"
          :clearable="false"
        >
        </el-date-picker>
      </div>
      <div class="shadow">
        <div class="insure_div">
          <div
            v-for="({ name, src, unit, value }, index) in insureList"
            :key="index"
          >
            <img :src="src" alt="" />
            <div>
              <h5>{{ name }}</h5>
              <span>
                <i>{{ value }}</i>
                <em>{{ unit }}</em>
              </span>
            </div>
          </div>
        </div>
        <div class="insurance_div">
          <p>
            总保险费用：<i>{{ toThousands(insureObj.totalPremiumAmount) }}</i>
            元
          </p>
          <p>
            自缴保费：<i>{{ toThousands(insureObj.totalSelfPremiumAmount) }}</i>
            元
          </p>
        </div>
      </div>
      <div class="state_div">
        <div
          v-for="(
            { name, numberText, number, sumText, sum, pageName }, index
          ) in stateList"
          :key="index"
          class="shadow"
        >
          <h5>{{ name }}</h5>
          <p>
            <span>{{ numberText }}</span>
            <i>{{ number }}</i>
          </p>
          <p>
            <span>{{ sumText }}</span>
            <i>{{ sum }}</i>
          </p>
        </div>
      </div>
    </div>
    <calendar :visible="dialogVisible" @closeFun="closeFun"></calendar>
    <fu-box></fu-box>
  </div>
</template>
<script>
import { formatDate } from "@/utils";
import calendar from "./calendar.vue";
import FuBox from "../compoments/FuBox.vue";
import { farm, policyOverview } from "@/api/request/snkd.produce";
import { mapState } from "vuex";
import { SessionStorage } from "@/utils/storage";
export default {
  components: { calendar, FuBox },
  data() {
    return {
      dataList: [
        {
          name: "在田面积",
          value: "",
        },
        {
          name: "种养面积",
          value: "",
        },
        {
          name: "待投保面积",
          value: "",
        },
      ],
      time: [],
      insureList: [
        {
          name: "保险保单数量",
          src: require("@/assets/images/Insurance/icon3.png"),
          unit: "个",
          value: "",
        },
        {
          name: "已投保面积",
          src: require("@/assets/images/Insurance/icon2.png"),
          unit: "亩",
          value: "",
        },
        {
          name: "已理赔总金额",
          src: require("@/assets/images/Insurance/icon1.png"),
          unit: "元",
          value: "",
        },
      ],
      stateList: [
        {
          name: "待支付",
          numberText: "订单数量（个）：",
          number: 0,
          sumText: "订单金额（元）：",
          sum: 0,
          pageName: {
            id: 1,
            name: "订单记录",
          },
        },
        {
          name: "保障中",
          numberText: "保单数量（个）：",
          number: 0,
          sumText: "保单金额（元）：",
          sum: 0,
          pageName: {
            id: 0,
            name: "保险保单",
          },
        },
        {
          name: "理赔成功",
          numberText: "保单数量（个）：",
          number: 0,
          sumText: "理赔金额（元）：",
          sum: 0,
          pageName: {
            id: 0,
            name: "保险保单",
          },
        },
        {
          name: "未发生理赔",
          numberText: "保单数量（个）：",
          number: 0,
          sumText: "保单金额（元）：",
          sum: 0,
          pageName: {
            id: 0,
            name: "保险保单",
          },
        },
      ],
      pickerDateOptions: {
        disabledDate(time) {
          return (
            time.getTime() >
            new Date(new Date().getTime() - 3600 * 1000 * 24).getTime()
          );
        },
      },
      dialogVisible: false,
      insureObj: {
        totalPremiumAmount: 0,
        totalSelfPremiumAmount: 0,
      },
      loading: false,
      insureInfo: {},
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  created() {
    this.insureInfo = SessionStorage.get("insureInfo");
    this.defaultTime();
    this.getPageData();
  },
  methods: {
    goPage(params) {
      if (params != 2) return;
      this.$router.push({ path: "/Insure", query: { state: true } });
    },
    defaultTime() {
      this.time = [
        formatDate(new Date(), "yyyy"),
        formatDate(
          new Date(new Date().getTime() - 3600 * 1000 * 24),
          "yyyy-MM-dd"
        ),
      ];
    },
    async plantingAcreData() {
      try {
        return await farm.statisticsFarmAcreAndOnPlantingAcreService({
          companyId: this.companyId,
          farmId: this.farmId,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async OrderLandAcreData() {
      try {
        return await farm.sumAwaitInsureOrderLandAcreService({
          companyId: this.companyId,
          farmId: this.farmId,
          insureId: this.insureInfo.id,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async policyOverviewData() {
      try {
        const [startTime, endTime] = this.time;
        const {
          noClaimOccurredAmount,
          noClaimOccurredCount,
          safeguardPolicyAmount,
          safeguardPolicyCount,
          successfulClaimAmount,
          successfulClaimCount,
          totalClaimsAmount,
          totalPolicyAcre,
          totalPolicyCount,
          totalPremiumAmount,
          totalSelfPremiumAmount,
          unpaidOrderAmount,
          unpaidOrderCount,
        } = await policyOverview({
          companyId: this.companyId,
          farmId: this.farmId,
          insureId: this.insureInfo.id,
          startTime: formatDate(startTime, "yyyy-MM-dd"),
          endTime: formatDate(endTime, "yyyy-MM-dd"),
        });
        this.insureObj.totalPremiumAmount = totalPremiumAmount;
        this.insureObj.totalSelfPremiumAmount = totalSelfPremiumAmount;
        this.insureList[0].value = totalPolicyCount;
        this.insureList[1].value = totalPolicyAcre;
        this.insureList[2].value = totalClaimsAmount;
        this.stateList[0].number = unpaidOrderCount;
        this.stateList[0].sum = unpaidOrderAmount;
        this.stateList[1].number = safeguardPolicyCount;
        this.stateList[1].sum = safeguardPolicyAmount;
        this.stateList[2].number = successfulClaimCount;
        this.stateList[2].sum = successfulClaimAmount;
        this.stateList[3].number = noClaimOccurredCount;
        this.stateList[3].sum = noClaimOccurredAmount;
      } catch (error) {
        console.log(error);
      }
    },
    async getPageData() {
      this.loading = true;
      try {
        const [
          {
            value: { allLandAcre, allLandAcreOnPlanting },
          },
          {
            value: { acre },
          },
        ] = await Promise.allSettled([
          this.plantingAcreData(),
          this.OrderLandAcreData(),
          this.policyOverviewData(),
        ]);
        this.dataList[0].value = allLandAcre || 0;
        this.dataList[1].value = allLandAcreOnPlanting || 0;
        this.dataList[2].value = acre || 0;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    closeFun() {
      this.dialogVisible = false;
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
  },
};
</script>
<style lang="scss" scoped>
.page_box {
  padding: 37px 24px 0;
}
.head_div {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.data_div {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #f7f9fb;
  width: 860px;
  padding: 34px 0 35px;
  div {
    color: #000;
    font-size: 18px;
    text-align: center;
    padding: 5px 0;
    h5 {
      padding-bottom: 10px;
    }
    span {
      display: flex;
      align-items: flex-end;
      i {
        font-style: normal;
        color: #2e333b;
        font-size: 30px;
        font-weight: 700;
      }
      em {
        font-style: normal;
        padding-bottom: 2px;
      }
      img {
        display: block;
        height: 30px;
        margin-bottom: -5px;
      }
    }
  }
}

.colorsp {
  cursor: pointer;
  i,
  em {
    color: #64c3a4 !important;
  }
}

.date_div {
  width: 270px;
  border: 1px solid #eee;
  box-sizing: border-box;
  padding-top: 14px;
  > img {
    width: 64px;
    display: block;
    margin: 0 auto 10px;
  }
  div {
    color: #64c3a4;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}

.time_div {
  display: flex;
  justify-content: space-between;
  padding: 17px 0 13px;
  span {
    color: #333;
    font-size: 20px;
    border-left: 4px solid #64c3a4;
    padding-left: 14px;
    line-height: 36px;
  }
}
.shadow {
  border-radius: 20px;
  box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
}

.insure_div {
  display: flex;
  justify-content: space-around;
  padding: 55px 0 56px;
  border-bottom: 1px solid #eee;
  > div {
    display: flex;
    align-items: center;
    img {
      width: 86px;
      display: block;
      margin-right: 38px;
    }
    div {
      h5 {
        color: #000;
        font-size: 20px;
        padding-bottom: 18px;
      }
      span {
        i {
          color: #64c3a4;
          font-size: 30px;
          font-weight: 700;
        }
        em {
          color: #000;
          font-size: 18px;
        }
      }
    }
  }
}

.insurance_div {
  display: flex;
  justify-content: center;
  padding: 24px 0;
  p {
    color: #000;
    font-size: 20px;
    i {
      color: #64c3a4;
      font-size: 24px;
      font-weight: 700;
    }
  }
}

.insurance_div > :first-child {
  margin-right: 84px;
}

.state_div {
  display: flex;
  justify-content: space-around;
  margin-top: 24px;
  > div {
    width: 273px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    h5 {
      color: #333;
      font-size: 20px;
      font-weight: 700;
      padding-bottom: 10px;
    }
    p {
      display: flex;
      justify-content: space-between;
      padding-top: 23px;
      span {
        color: #888;
      }
      i {
        color: #64c3a4;
        font-weight: 700;
      }
    }
  }
}
</style>
